import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { GraduationCap, Award, BookOpen, Users, Lightbulb, Music, Bike, Code } from 'lucide-react';

const Education = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, threshold: 0.1 });

  const education = [
    {
      degree: "B.E. (Computer Science / IT)",
      institution: "Bannari Amman Institute of Technology",
      location: "Tamil Nadu",
      icon: GraduationCap
    }
  ];

  const softSkills = [
    { name: "System Design", icon: Code },
    { name: "Problem Solving", icon: Lightbulb },
    { name: "Debugging", icon: Award },
    { name: "Collaboration", icon: Users },
    { name: "Automation", icon: BookOpen },
    { name: "Leadership", icon: Award }
  ];

  const hobbies = [
    { name: "Exploring new tech", icon: Code },
    { name: "Building side projects", icon: Lightbulb },
    { name: "Writing tech blogs", icon: BookOpen },
    { name: "Cycling", icon: Bike },
    { name: "Music", icon: Music }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section id="education" className="education section">
      <div className="container">
        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          <motion.h2 
            className="section-title"
            variants={itemVariants}
          >
            🎓 Education & More
          </motion.h2>

          {/* Education */}
          <motion.div 
            className="education-content"
            variants={itemVariants}
          >
            {education.map((edu, index) => (
              <motion.div
                key={index}
                className="education-card"
                whileHover={{ 
                  y: -10,
                  scale: 1.02,
                  boxShadow: "0 20px 40px rgba(125, 83, 246, 0.2)"
                }}
              >
                <div className="education-icon">
                  <edu.icon size={32} />
                </div>
                <div className="education-info">
                  <h3>{edu.degree}</h3>
                  <p className="institution">{edu.institution}</p>
                  <p className="location">{edu.location}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>

          {/* Soft Skills */}
          <motion.div 
            className="soft-skills-section"
            variants={itemVariants}
          >
            <h3 className="subsection-title">🧠 Soft Skills</h3>
            <div className="skills-badges-grid">
              {softSkills.map((skill, index) => (
                <motion.div
                  key={index}
                  className="skill-badge-item"
                  variants={itemVariants}
                  whileHover={{ 
                    scale: 1.1,
                    y: -5,
                    backgroundColor: "var(--accent-color)",
                    color: "white"
                  }}
                >
                  <skill.icon size={18} />
                  <span>{skill.name}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Hobbies */}
          <motion.div 
            className="hobbies-section"
            variants={itemVariants}
          >
            <h3 className="subsection-title">❤️ Hobbies & Interests</h3>
            <div className="hobbies-grid">
              {hobbies.map((hobby, index) => (
                <motion.div
                  key={index}
                  className="hobby-card"
                  variants={itemVariants}
                  whileHover={{ 
                    scale: 1.05,
                    rotate: 2,
                    boxShadow: "0 10px 25px rgba(125, 83, 246, 0.2)"
                  }}
                >
                  <hobby.icon size={24} />
                  <span>{hobby.name}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Education;
